export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGIN_START = 'LOGIN_START';
export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGIN_BACKEND_PICKED = 'BACKEND_PICKED';
export const LOGIN_SELECT_DEFAULT_BACKEND = 'LOGIN_SELECT_DEFAULT_BACKEND';

export const INSTALLERS_SUCCESS = 'INSTALLERS_SUCCESS';
export const INSTALLERS_ERROR = 'INSTALLERS_ERROR';
export const INSTALLERS_START = 'INSTALLERS_START';

export const INSTALLER_ADD_SUCCESS = 'INSTALLER_ADD_SUCCESS';
export const INSTALLER_ADD_ERROR = 'INSTALLER_ADD_ERROR';
export const INSTALLER_ADD_START = 'INSTALLER_ADD_START';

export const INSTALLER_COMPANIES_SUCCESS = 'INSTALLER_COMPANIES_SUCCESS';
export const INSTALLER_COMPANIES_ERROR = 'INSTALLER_COMPANIES_ERROR';
export const INSTALLER_COMPANIES_START = 'INSTALLER_COMPANIES_START';

export const INSTALLER_COMPANY_ADD_START = 'INSTALLER_COMPANY_ADD_START';
export const INSTALLER_COMPANY_ADD_ERROR = 'INSTALLER_COMPANY_ADD_ERROR';
export const INSTALLER_COMPANY_ADD_SUCCESS = 'INSTALLER_COMPANY_ADD_SUCCESS';

export const INSTALLER_COMPANY_DISABLE_START = 'INSTALLER_COMPANY_DISABLE_START';
export const INSTALLER_COMPANY_DISABLE_ERROR = 'INSTALLER_COMPANY_DISABLE_ERROR';
export const INSTALLER_COMPANY_DISABLE_SUCCESS = 'INSTALLER_COMPANY_DISABLE_SUCCESS';

export const INSTALLER_COMPANY_UPDATE_START = 'INSTALLER_COMPANY_UPDATE_START';
export const INSTALLER_COMPANY_UPDATE_ERROR = 'INSTALLER_COMPANY_UPDATE_ERROR';
export const INSTALLER_COMPANY_UPDATE_SUCCESS = 'INSTALLER_COMPANY_UPDATE_SUCCESS';

export const INSTALLER_UPDATE_START = 'INSTALLER_UPDATE_START';
export const INSTALLER_UPDATE_ERROR = 'INSTALLER_UPDATE_ERROR';
export const INSTALLER_UPDATE_SUCCESS = 'INSTALLER_UPDATE_SUCCESS';

export const INSTALLER_DISABLE_START = 'INSTALLER_DISABLE_START';
export const INSTALLER_DISABLE_ERROR = 'INSTALLER_DISABLE_ERROR';
export const INSTALLER_DISABLE_SUCCESS = 'INSTALLER_DISABLE_SUCCESS';

export const INSTALLER_COMPANY_PASSWORD_START = 'INSTALLER_COMPANY_PASSWORD_START';
export const INSTALLER_COMPANY_PASSWORD_SUCCESS = 'INSTALLER_COMPANY_PASSWORD_SUCCESS';
export const INSTALLER_COMPANY_PASSWORD_ERROR = 'INSTALLER_COMPANY_PASSWORD_ERROR';

export const INSTALLER_PASSWORD_START = 'INSTALLER_PASSWORD_START';
export const INSTALLER_PASSWORD_SUCCESS = 'INSTALLER_PASSWORD_SUCCESS';
export const INSTALLER_PASSWORD_ERROR = 'INSTALLER_PASSWORD_ERROR';

export const CHANGE_PASSWORD_START = 'CHANGE_PASSWORD_START';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

export const PASSWORD_UPDATE_START = 'PASSWORD_UPDATE_START';
export const PASSWORD_UPDATE_ERROR = 'PASSWORD_UPDATE_ERROR';
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS';

export const COMMERCIAL_OFFERS_START = 'COMMERCIAL_OFFERS_START';
export const COMMERCIAL_OFFERS_ERROR = 'COMMERCIAL_OFFERS_ERROR';
export const COMMERCIAL_OFFERS_SUCCESS = 'COMMERCIAL_OFFERS_SUCCESS';

export const COMMERCIAL_OFFER_SAVE_START = 'COMMERCIAL_OFFER_SAVE_START';
export const COMMERCIAL_OFFER_SAVE_ERROR = 'COMMERCIAL_OFFER_SAVE_ERROR';
export const COMMERCIAL_OFFER_SAVE_SUCCESS = 'COMMERCIAL_OFFER_SAVE_SUCCESS';

export const FILTER_SHOP_START = 'FILTER_SHOP_START';
export const FILTER_SHOP_ERROR = 'FILTER_SHOP_ERROR';
export const FILTER_SHOP_SUCCESS = 'FILTER_SHOP_SUCCESS';

export const FILTER_SHOP_SAVE_START = 'FILTER_SHOP_SAVE_START';
export const FILTER_SHOP_SAVE_ERROR = 'FILTER_SHOP_SAVE_ERROR';
export const FILTER_SHOP_SAVE_SUCCESS = 'FILTER_SHOP_SAVE_SUCCESS';

export const PRODUCTS_START = 'PRODUCTS_START';
export const PRODUCTS_ERROR = 'PRODUCTS_ERROR';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';

export const PRODUCT_ADD_START = 'PRODUCT_ADD_START';
export const PRODUCT_ADD_ERROR = 'PRODUCT_ADD_ERROR';
export const PRODUCT_ADD_SUCCESS = 'PRODUCT_ADD_SUCCESS';

export const PRODUCT_UPDATE_START = 'PRODUCT_UPDATE_START';
export const PRODUCT_UPDATE_ERROR = 'PRODUCT_UPDATE_ERROR';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';

export const PRODUCT_DISABLE_START = 'PRODUCT_DISABLE_START';
export const PRODUCT_DISABLE_ERROR = 'PRODUCT_DISABLE_ERROR';
export const PRODUCT_DISABLE_SUCCESS = 'PRODUCT_DISABLE_SUCCESS';

export const SOFTWAREVERSIONS_START = 'SOFTWAREVERSIONS_START';
export const SOFTWAREVERSIONS_ERROR = 'SOFTWAREVERSIONS_ERROR';
export const SOFTWAREVERSIONS_SUCCESS = 'SOFTWAREVERSIONS_SUCCESS';

export const SOFTWAREVERSION_ADD_START = 'SOFTWAREVERSION_ADD_START';
export const SOFTWAREVERSION_ADD_ERROR = 'SOFTWAREVERSION_ADD_ERROR';
export const SOFTWAREVERSION_ADD_SUCCESS = 'SOFTWAREVERSION_ADD_SUCCESS';

export const SOFTWAREVERSION_DELETE_START = 'SOFTWAREVERSION_DELETE_START';
export const SOFTWAREVERSION_DELETE_ERROR = 'SOFTWAREVERSION_DELETE_ERROR';
export const SOFTWAREVERSION_DELETE_SUCCESS = 'SOFTWAREVERSION_DELETE_SUCCESS';

export const SOFTWAREVERSION_UPDATE_START = 'SOFTWAREVERSION_UPDATE_START';
export const SOFTWAREVERSION_UPDATE_ERROR = 'SOFTWAREVERSION_UPDATE_ERROR';
export const SOFTWAREVERSION_UPDATE_SUCCESS = 'SOFTWAREVERSION_UPDATE_SUCCESS';

export const UPLOAD_START = 'UPLOAD_START';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';

export const INSTALLER_COMPANY_SUCCESS = 'INSTALLER_COMPANY_SUCCESS';
export const INSTALLER_COMPANY_ERROR = 'INSTALLER_COMPANY_ERROR';
export const INSTALLER_COMPANY_START = 'INSTALLER_COMPANY_START';

export const LOAD_MANAGER_SUCCESS = 'LOAD_MANAGER_SUCCESS';
export const LOAD_MANAGER_ERROR = 'LOAD_MANAGER_ERROR';
export const LOAD_MANAGER_START = 'LOAD_MANAGER_START';

export const LOAD_DOCUMENTS_SUCCESS = 'LOAD_DOCUMENTS_SUCCESS';
export const LOAD_DOCUMENTS_ERROR = 'LOAD_DOCUMENTS_ERROR';
export const LOAD_DOCUMENTS_START = 'LOAD_DOCUMENTS_START';

export const CHANGE_DOCUMENT_POSITION_SUCCESS = 'CHANGE_DOCUMENT_POSITION_SUCCESS';
export const CHANGE_DOCUMENT_POSITION_ERROR = 'CHANGE_DOCUMENT_POSITION_ERROR';
export const CHANGE_DOCUMENT_POSITION_START = 'CHANGE_DOCUMENT_POSITION_START';

export const DOCUMENT_ADD_SUCCESS = 'DOCUMENT_ADD_SUCCESS';
export const DOCUMENT_ADD_ERROR = 'DOCUMENT_ADD_ERROR';
export const DOCUMENT_ADD_START = 'DOCUMENT_ADD_START';

export const DOCUMENT_DELETE_START = 'DOCUMENT_DELETE_START';
export const DOCUMENT_DELETE_ERROR = 'DOCUMENT_DELETE_ERROR';
export const DOCUMENT_DELETE_SUCCESS = 'DOCUMENT_DELETE_SUCCESS';

export const ARTICLES_FOR_PRODUCT_SUCCESS = 'ARTICLES_FOR_PRODUCT_SUCCESS';
export const ARTICLES_FOR_PRODUCT_ERROR = 'ARTICLES_FOR_PRODUCT_ERROR';

export const CHANGE_TAB = 'TAB_CHANGED';

export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';



// WEBPACK FOOTER //
// /src/constants/Constants.js